/**
 * Query keys for the Garage feature.
 *
 * Namespaced under a single root so a mutation can invalidate the whole feature with one call when
 * a change has wide effects, or a single vehicle when it does not.
 */
export const garageKeys = {
  /** Every garage query. */
  all: ['garage'] as const,
  /** The vehicle list. */
  list: () => [...garageKeys.all, 'list'] as const,
  /** One vehicle with everything attached. */
  vehicle: (vehicleId: string) => [...garageKeys.all, 'vehicle', vehicleId] as const,
  /** A VIN decode result. */
  vin: (vin: string) => [...garageKeys.all, 'vin', vin] as const,
};
